import { ProductivityIntegrationsModule } from '@core/modules/productivity-integrations/productivity-integrations.module'
import { create, register, useModal, show, hide } from '@ebay/nice-modal-react'
import { FunctionComponent } from 'react'
import { ASM_DIALOGS_MAP } from '@core/services/dialog/dialog.service.config'
import { BaseService } from '@core/base/service/base-service'

/**
 * All Dialogs are at /src/ui/dialogs directory
 */

type TDialogConfig = { id: string }

export const DialogService = new (class DialogService extends BaseService {
    constructor() {
        super('dialog.service')
        this.listenToEvents()
    }

    listenToEvents() {
        this.$eventBus.on('summary_loaded', ({ firstVisit, hasDomains }) => {
            if (firstVisit && !hasDomains) {
                this.showDialog(ASM_DIALOGS_MAP.EMPTY_DOMAINS)
            }
        })
    }

    createDialog<DialogProps extends object>(
        config: TDialogConfig,
        dialog: FunctionComponent<DialogProps>
    ) {
        register(config.id, create(dialog))
        return config.id
    }

    async showDialog(dialog: TDialogConfig, args?: Record<string, unknown>) {
        const dialogs = import.meta.glob('/src/ui/dialogs/*/index.tsx')

        for (const key in dialogs) {
            if (key.includes(dialog.id)) {
                await dialogs[key]()
                if (dialog.id === 'wizer-transition-screen-dialog') {
                    await ProductivityIntegrationsModule.setClicked(false)
                }
                await show(dialog.id, args)
            }
        }
    }

    useDialog = useModal
    hideDialog = hide
})()
